/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import _ from '../../../@lodash';
import { Box } from '@mui/system';
import clsx from 'clsx';
import Typography from '@mui/material/Typography';

function ReviewContent(props) {
  const { eventInfo, lessons } = props;

  // match eventInfo to one of the lessons
  function getLessonById(lesson_id) {
    return lessons.find((lesson) => lesson.id === lesson_id);
  }
  

  const theme = useTheme();
  const cycles = [
    { title: 'SB ALPHA Development', color: '#FF55BF', id: 'dev_alpha_internal' },
      { title: 'SB ALPHA Review', color: '#80F2E7', id: 'dev_alpha' },
      { title: 'SB ALPHA Revision', color: '#FF55BF', id: 'dev_alpha_revision' },
      { title: 'SB BETA Review', color: '#48BF91', id: 'dev_beta' },
      { title: 'SB BETA Revision', color: '#FF55BF', id: 'dev_beta_revision' },
      { title: 'SB Final Review and Acceptance', color: '#013BB1', id: 'dev_final' },
      { title: 'IMI ALPHA Development', color: '#8A2FFF', id: 'prod_alpha_internal' },
      { title: 'IMI ALPHA Review', color: '#80F2E7', id: 'prod_alpha' },
      { title: 'IMI ALPHA Revision', color: '#8A2FFF', id: 'prod_alpha_revision' },
      { title: 'IMI BETA Review', color: '#48BF91', id: 'prod_beta' },
      { title: 'IMI BETA Revision', color: '#8A2FFF', id: 'prod_beta_revision' },
      { title: 'IMI Final Review and Acceptance', color: '#013BB1', id: 'prod_final' },
      { title: 'Pre-Trials QA', color: '#FF5454', id: 'trials_pre' },
      { title: 'Individual Trials Review', color: '#80F2E7', id: 'trials_individual' },
      { title: 'Individual Trials Revision', color: '#FF5454', id: 'trials_individual_revision' },
      { title: 'Group Trials Review', color: '#80F2E7', id: 'trials_group' },
      { title: 'Group Trials Revision', color: '#FF5454', id: 'trials_group_revision' },
      { title: 'Trials Final Review and Acceptance', color: '#013BB1', id: 'trials_final' },
  ];

  const cycleId = eventInfo.event.extendedProps.cycle;
  const cycle = _.find(cycles, { id: cycleId });
  let label = getLessonById(eventInfo.event.extendedProps.lessons[0])?.label;

  if (eventInfo.event.extendedProps.lessons?.length === lessons.length) {
    label = 'All';
  } else if (eventInfo.event.extendedProps.lessons?.length > 1) {
    label = 'Multiple';
  }

  return (
    <Box
      sx={{
        backgroundColor: cycle?.color,
        color: cycle && theme.palette.getContrastText(cycle?.color),
      }}
      className={clsx('flex items-center w-full rounded-4 px-8 py-2 h-22 text-white shrink-0')}
    >
      <Typography noWrap className="text-12 font-semibold truncate min-w-0">{label}: {cycle.title}</Typography>
    </Box>
  );
}

export default ReviewContent;